export default __webpack_public_path__ + "static/media/pantalon-bombero-mujer.3456d013.png";